import Page from '../base/Page';
import Map from '../modules/PropertyMap';
import {clustererStyles, markerStyles, markerInfoWindowTemplate} from '../modules/includes/PropertyListingModuleSettings';

export default class PropertyDetailPage extends Page
{
    constructor() {
        super('.property-detail-page');
    }

    init() {
        this.initMap();
        this.addEvent('.button__enquire', 'click', e => this.showEnquiryForm(e));
        this.addEvent('#enquire-form-overlay', 'click', e => this.hideEnquiryForm(e));
        this.sidebarHeight();
        this.setupStickSide();
        this.bindSideWindowScroll();

        //run manually the first time
        this.stickySideOnScroll();

        //this.bindForm();
    }

    initMap() {
        var map = this.childElements('.property-map');
        if(map.length){
            let data = map.data('location');
            this.map = new Map(map, clustererStyles, markerStyles, markerInfoWindowTemplate);
            this.map.minZoom = 12;
            this.map.maxZoom = 17;
            this.map._locations = JSON.stringify(data);
            this.map.callback = (locations) => this.map.updateLocations(JSON.stringify(data));
            this.map.init();
        }
    }

    showEnquiryForm(e){
        e.preventDefault();
        $('#enquire-form-overlay').show();
    }

    hideEnquiryForm(e){
        if(e.target.id == 'enquire-form-overlay') {
            $(e.target).hide();
        }
    }

    bindForm() {
        var form = this.childElements('form');
        if(form.length){
            this.form = new Form(form);
            this.form.init();
        }
    }

    bindSideWindowScroll() {
        $(window).on('scroll', _.debounce(() => {
            this.stickySideOnScroll();
        }, 0));
    }

    onWindowResize() {
        this.sidebarHeight();
        this.setupStickSide();
    }

    /**
     * Save the sidebar offset so it doesn't change as page is scrolled/fixed/unfixed
     */
    setupStickSide() {
        //wait for carousel to load as it pushes it down
        if($('.property-detail__side').length) {
            setTimeout(() => this.initialSideOffset = $('.property-detail__side').offset().top, 10);
        }

    }

    stickySideOnScroll() {
        let side = $('.property-detail__side'),
            headerHeight = $('.navbar-fixed-top').height(),
            sideHeight = side.height(),
            topScrollCheck = this.initialSideOffset - headerHeight,
            bottomScrollCheck = $('.property-detail-page > .container').height() + $('.property-detail__slideshow').outerHeight(true) - headerHeight - sideHeight,
            windowScrollTop = $(window).scrollTop(),
            contentHeight = $('.property-detail__content').height();

        if (sideHeight < contentHeight) {
            side.addClass("sticky");

            if (windowScrollTop > topScrollCheck && windowScrollTop < bottomScrollCheck) {
                side.removeClass("bottom");
                side.addClass("fixed");
            }
            else if (windowScrollTop > bottomScrollCheck) {
                side.removeClass("fixed");
                side.addClass("bottom");
            }
            else {
                side.removeClass("fixed");
                side.removeClass("bottom");
            }
        }
    }

    sidebarHeight(){
        let contentHeight = $('.property-detail__content').height(),
            sideHeight = $('.property-detail__side').height();

        if (sideHeight < contentHeight) {
            $('.sidebar-outer').css('height', contentHeight);
        }
    }
}


// WEBPACK FOOTER //
// ./javascript/pages/PropertyDetailPage.js